<template>
  <div id="app" class="wrapper">
    <div class="spMenuModal">
      <div class="spMenuModal__overlay"></div>
    </div>
    <Header v-bind:roomNo="roomNo"></Header>
    <div class="l-defalutLayout__mainVisual" v-if="mainVisualShow">
      <aside>
        <img
          :src="
            `/assets/custom/${currentUser.mansion.dai_bunrui}/${currentUser.mansion.chu_bunrui}/${currentUser.mansion.id}/img/mainVisual.jpg`
          "
          alt="mainVisual"
        />
      </aside>
    </div>
    <main class="l-defalutLayout__mainWrap">
      <div class="l-defalutLayout__main">
        <GlobalNav />
        <div class="l-defalutLayout__main__container">
          <router-view></router-view>
          <div class="l-defalutLayout__calendar">
            <vc-calendar
              ref="calendar"
              is-expanded
              :firstDayOfWeek="1"
              @dayclick="onDayClick"
              @update:from-page="onFromPage"
              @update:to-page="onToPage"
              :attributes="attrs"
              :v-model="currentDate"
              timezone="Asia/Pyongyang"
              locale="ja"
            ></vc-calendar>
          </div>
        </div>
      </div>
    </main>
    <Footer></Footer>
    <ButtonScrollInPageTop></ButtonScrollInPageTop>
  </div>
</template>

<script>
// import gtag from "../mixin/gtag";
import InfoService from "../services/info.service";
import BoDInfoService from "../services/bod-info.service";
import GlobalInfoService from "../services/global-info.service";
import store from "../store";
import Header from "../components/Header.vue";
import Footer from "../components/Footer.vue";
import ButtonScrollInPageTop from "../components/ButtonScrollInPageTop.vue";
// import NaviListMobileContractor from "../components/NaviListMobileContractor.vue";
// import NaviListMobileResident from "../components/NaviListMobileResident.vue";
// import NaviListContractor from "../components/NaviListContractor.vue";
// import NaviListResident from "../components/NaviListResident.vue";
import GlobalNav from "../components/GlobalNav.vue";
import dayjs from "@/libs/day.js";
// import $ from "jquery";
export default {
  components: {
    Header,
    Footer,
    ButtonScrollInPageTop,
    // NaviListMobileContractor,
    // NaviListMobileResident,
    // NaviListResident,
    // NaviListContractor,
    GlobalNav,
  },
  // mixins: [gtag],
  name: "default-layout",
  async mounted() {
    var routeInstance = this.$route;

    console.log("default-layout mounted-1");
    await this.$nextTick();
    this.createTitleDesc(routeInstance);
    console.log("default-layout mounted-2");
    this.appendFile();

    console.log("default-layout mounted-3");
    window.initMenu();

    //メインビジュアルを表示、非表示
    this.mainVisualShowToggle();
  },
  beforeMount() {
    //
    const currentUser = store.state.auth.user;

    if (
      currentUser != null &&
      currentUser.mansion._id != this.$route.params.mc_code
    ) {
      this.$router.push({
        name: "notfound404",
      });
    }
    if (!currentUser.email) {
      this.$router.push({
        name: "email-required",
        params: { mc_code: currentUser.mansion._id },
      });
    }
  },
  computed: {
    roomNo() {
      return this.currentUser ? this.currentUser.roomNo : "";
    },
    isShow() {
      const ignorePaths = [
        "login",
        "password-reminder",
        "notfound404",
        "verify-email",
      ];
      //
      //
      return (
        ignorePaths.indexOf(this.$route.name) == -1 && this.currentUser != null
      );
    },
    mansionName() {
      //
      //
      if (this.mansion) {
        return this.mansion.name ? this.mansion.name : "";
      } else {
        return "";
      }
    },
    user() {
      return this.currentUser;
    },
    showAdminBoard() {
      return true;
      // if (this.currentUser && this.currentUser.role) {
      //   // eslint-disable-next-line
      //
      //   return this.currentUser.role == "Admin";
      // }

      // return false;
    },
    showModeratorBoard() {
      return true;
      // if (this.currentUser && this.currentUser.roles) {
      //   return this.currentUser.roles.includes("ROLE_MODERATOR");
      // }

      // return false;
    },
  },
  watch: {
    // eslint-disable-next-line
    $route(routeInstance, from) {
      //メインビジュアルを表示、非表示
      this.mainVisualShowToggle();
      this.createTitleDesc(routeInstance);
    },
  },
  data() {
    return {
      mainVisualShow: true,
      currentMonth: { year: 0, month: 0 },
      news: [],
      defaultIndex: "/",
      masks: {
        title: "YYYY MM",
        weekdays: "W",
        navMonths: "MMM",
        input: ["L", "YYYY-MM-DD", "YYYY/MM/DD"],
        dayPopover: "WWW, MMM D, YYYY",
        data: ["L", "YYYY-MM-DD", "YYYY/MM/DD"],
      },
      attrs: [
        {
          key: "today",
          highlight: {
            color: "orange",
            fillMode: "light",
          },
          dates: dayjs().toDate(),
        },
        {
          key: "schedule",
          dot: true,
          dates: dayjs().toDate(),
          customData: { _id: "abc" },
        },
        {
          key: "schedule",
          highlight: {
            start: { fillMode: "outline" },
            base: { fillMode: "light" },
            end: { fillMode: "outline" },
          },
          dates: { start: new Date(2021, 5, 14), end: new Date(2021, 5, 20) },
          customData: { _id: "qwe" },
        },
        {
          key: "schedule2",
          highlight: {
            start: { fillMode: "outline" },
            base: { fillMode: "light" },
            end: { fillMode: "outline" },
          },
          dates: { start: new Date(2021, 5, 16), end: new Date(2021, 5, 25) },
          customData: { _id: "asd" },
        },
      ],
    };
  },
  // 'http://localhost:8080/assets/custom/dai_1/defalut.css'
  methods: {
    mainVisualShowToggle() {
      if (
        window.location.href ===
        window.location.origin + "/" + this.$route.params.mc_code
      ) {
        this.mainVisualShow = true;
      } else {
        this.mainVisualShow = false;
      }
    },
    dispDate(obj) {
      let startDate, endDate, startTime;
      let endTime = this.$date(obj.calender_range.end).tz().format("HH:mm");
      if (obj.type == "global") {
        startDate = this.$date(obj.calender_range[0]).tz().format("MM.DD");
        endDate = this.$date(obj.calender_range[1]).tz().format("MM.DD");
        startTime = this.$date(obj.calender_range[0]).tz().format("HH:mm");
        endTime = this.$date(obj.calender_range[1]).tz().format("HH:mm");
      } else {
        startDate = this.$date(obj.calender_range.start).tz().format("MM.DD");
        endDate = this.$date(obj.calender_range.end).tz().format("MM.DD");
        startTime = this.$date(obj.calender_range.start).tz().format("HH:mm");
        endTime = this.$date(obj.calender_range.end).tz().format("HH:mm");
      }

      let result = "";
      if (obj.is_dispTime) {
        if (startDate != endDate) {
          result = `${startDate} ${startTime} 〜 ${endDate} ${endTime}`;
        } else if (startTime != endTime) {
          result = `${startDate} ${startTime} 〜 ${endTime}`;
        } else {
          result = `${startDate} ${startTime} 〜`;
        }
      } else {
        if (startDate != endDate) {
          result = `${startDate} 〜 ${endDate}`;
        } else {
          result = `${startDate}`;
        }
      }

      return result;
    },
    // eslint-disable-next-line
    onDayClick(obj) {
      //
      //
    },
    // eslint-disable-next-line
    onFromPage(obj) {
      //
      //
    },
    onToPage: async function(obj) {
      this.currentMonth = obj;
      //
      obj.is_schedule = true;
      obj.limit = 100;
      const response = await InfoService.list(obj);

      this.news = [];
      if (response.data.docs != undefined) {
        const docs1 = response.data.docs;

        for (let index = 0; index < docs1.length; index++) {
          const element = docs1[index];
          element.type = "normal";
          this.news.push(element);
        }
      }

      const response2 = await BoDInfoService.list(obj);
      //
      if (response2.data.docs != undefined) {
        const docs2 = response2.data.docs;

        for (let index = 0; index < docs2.length; index++) {
          const element = docs2[index];
          element.type = "bod";
          this.news.push(element);
        }
      }

      const responseGlobal = await GlobalInfoService.findCalender(obj);

      if (responseGlobal.length > 0) {
        for (let index = 0; index < responseGlobal.length; index++) {
          const element = responseGlobal[index];
          element.type = "global";
          this.news.push(element);
        }
      }

      this.news = Array.from(
        new Map(this.news.map(item => [item._id, item])).values(),
      );

      //

      this.attrs = [];

      for (let index = 0; index < this.news.length; index++) {
        const element = this.news[index];
        if (element.type == "global") {
          this.attrs.push({
            key: element._id,
            highlight: {
              start: { fillMode: "outline" },
              base: { fillMode: "light" },
              end: { fillMode: "outline" },
            },
            dates: {
              start: element.calender_range[0],
              end: element.calender_range[1],
            },
          });
        } else {
          this.attrs.push({
            key: element._id,
            highlight: {
              start: { fillMode: "outline" },
              base: { fillMode: "light" },
              end: { fillMode: "outline" },
            },
            dates: {
              start: element.calender_range.start,
              end: element.calender_range.end,
            },
          });
        }
      }

      this.attrs.push({
        key: "today",
        highlight: {
          color: "orange",
          fillMode: "light",
        },
        dates: dayjs().toDate(),
      });
    },
    onChangeMansion(value) {
      this.mansionName = value;
    },

    appendCSS(filePath) {
      let file = document.createElement("link");
      file.rel = "stylesheet";
      file.href = filePath;
      document.head.appendChild(file);
    },
    role2Ja: function(role) {
      const roleNames = {
        Admin: "管理者",
        ExternalParty: "外部関係者",
        Chairman: "理事長",
        Director: "理事",
        OwnedResident: "区分所有者",
        OwnedNonResident: "外部オーナー",
        RentResident: "賃借人",
        Others: "その他",
      };
      return roleNames[role];
    },
    logOut() {
      this.$store.dispatch("auth/logout");
      this.$router.push("/login");
      // window.location = "/login";
    },
  },
};
</script>

<style>
#app {
  /*  font-family: "Avenir", Helvetica, Arial, sans-serif;*/
  /*-webkit-font-smoothing: antialiased;*/
  /*-moz-osx-font-smoothing: grayscale;*/
  /*text-align: center;*/
  /*  color: #2c3e50;*/
  /* margin-top: 60px; */
}

.el-menu--horizontal > .el-menu-item.dock-right {
  float: right;
}

.title-margin {
  margin: 55px 0 20px;
}
</style>
